var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row margin-none centralize-child"},[_c('div',{staticClass:"metade input-field margin-bottom-0"},[_vm._t("input")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }